/** 费用管理 cost **/
// 病历邮寄 新替换原
// 邮寄接收 新替换原
// 隐藏 邮寄办理大菜单（由三个京东、邮政、顺丰替换）
import Layout from "@/views/layout/Layout";

const jtyRouter = {
  path: "/jyt",
  component: Layout,
  name: "jyt",
  // redirect: '/dataDic/departMan',
  // component: () => import('@/views/dataDic/index'),
  meta: {
    title: "简E通",
    icon: "jianETong",
    roles: ["jianEtong"]
  },
  alwaysShow: true,
  children: [
    // 病历
    {
      path: "medicalRecord",
      component: () => import("@/views/jyt/medicalRecord/index"),
      meta: {
        title: "病历服务",
        roles: ["binglifuwu"]
      },
      alwaysShow: true,
      children: [
        {
          path: "businessHan",
          component: () =>
            import("@/views/jyt/medicalRecord/businessHan/index"),
          meta: {
            title: "业务办理",
            roles: ["yewubanli"]
          },
          alwaysShow: true,
          children: [
            {
              path: "postAudit",
              component: () =>
                import("@/views/jyt/medicalRecord/businessHan/postAudit"),
              name: "邮寄审核",
              meta: {
                title: "邮寄审核",
                roles: ["youjishenhe"]
              },
              children: []
            },
            {
              path: "medicalRecordMailingEMS",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessHan/medicalRecordMailingEMS"
                ),
              name: "病历邮寄(邮政EMS)",
              meta: {
                title: "病历邮寄(邮政EMS)",
                roles: ["bingliyouji_ems"]
              },
              children: []
            },
            {
              path: "medicalRecordMailingJD",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessHan/medicalRecordMailingJD"
                ),
              name: "病历邮寄(京东物流)",
              meta: {
                title: "病历邮寄(京东物流)",
                roles: ["bingliyouji_jd"]
              },
              children: []
            },
            {
              path: "medicalRecordMailingSF",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessHan/medicalRecordMailingSF"
                ),
              name: "病历邮寄(顺丰快递)",
              meta: {
                title: "病历邮寄(顺丰快递)",
                roles: ["bingliyouji_sf"]
              },
              children: []
            },
            // {
            //   path: "medicalRecordMailing",
            //   component: () =>
            //     import(
            //       "@/views/jyt/medicalRecord/businessHan/medicalRecordMailing"
            //     ),
            //   name: "病历邮寄-原",
            //   meta: {
            //     title: "病历邮寄",
            //     roles: ["bingliyouji"]
            //   },
            //   children: []
            // },
            {
              path: "medicalRecordMailing",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessHan/medicalRecordMailing2"
                ),
              name: "病历邮寄",
              meta: {
                title: "病历邮寄",
                roles: ["bingliyouji"]
              },
              children: []
            },

            {
              path: "appointReceiveHandle",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessHan/appointReceiveHandle"
                ),
              name: "预约领取办理",
              meta: {
                title: "预约领取办理",
                roles: ["yuyuelingqubanli"]
              },
              children: []
            },
            {
              path: "appointReceiveConfirm",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessHan/appointReceiveConfirm"
                ),
              name: "预约领取确认",
              meta: {
                title: "预约领取确认",
                roles: ["yuyuelingququeren"]
              },
              children: []
            },
            // {
            // 	path: 'textPhoto',
            // 	component: () =>
            // 		import('@/views/jyt/medicalRecord/businessHan/textPhoto'),
            // 	name: '测试拍照',
            // 	meta: {
            // 		title: '测试拍照',
            // 		roles: ['renliziyuan']
            // 	},
            // 	children: []
            // },
            {
              path: "appointReceiveQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessHan/appointReceiveQuery"
                ),
              name: "预约领取查询",
              meta: {
                title: "预约领取查询",
                roles: ["yuyuelingquchaxun"]
              },
              children: []
            },
            {
              path: "turnSendQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/businessHan/turnSendQuery"),
              name: "转邮寄待确认查询",
              meta: {
                title: "转邮寄待确认查询",
                roles: ["zhuanyoujiquerenchaxun"] //  zhuanyoujiquerenchaxun
              },
              children: []
            },
            {
              path: "goodsManagement",
              component: () =>
                import("@/views/jyt/medicalRecord/businessHan/goodsManagement"),
              name: "货位管理",
              meta: {
                title: "货位管理",
                roles: ["huoweiguanli"]
              },
              children: []
            },
            // {
            //   path: "windowMan",
            //   component: () =>
            //     import("@/views/jyt/medicalRecord/businessHan/windowMan"),
            //   name: "窗口维护",
            //   meta: {
            //     title: "窗口维护",
            //     roles: ["bl_chuangkouweihu"]
            //   },
            //   children: []
            // },
            {
              path: "callNumber",
              component: () =>
                import("@/views/jyt/medicalRecord/businessHan/callNumber"),
              name: "窗口大屏",
              meta: {
                title: "窗口大屏",
                roles: ["bl_chuangkoudaping"]
              },
              children: []
            },

            {
              path: "queueList",
              component: () =>
                import("@/views/jyt/medicalRecord/businessHan/queueList"),
              name: "排队列表",
              meta: {
                title: "排队列表",
                roles: ["bl_paiduiliebiao"]
              },
              children: []
            },

            {
              path: "offlinePrintRecord",
              component: () =>
                import("@/views/jyt/medicalRecord/businessHan/offlinePrintRecord"),
              name: "线下办理记录",
              meta: {
                title: "线下办理记录",
                roles: ["bl_xianxiabanlijilu"]
              },
              children: []
            }
          ]
        },
        {
          path: "businessMan",
          component: () =>
            import("@/views/jyt/medicalRecord/businessMan/index"),
          meta: {
            title: "业务管理",
            roles: ["yewuguanli"]
          },
          alwaysShow: true,
          children: [
            {
              path: "invalidPaperManagement",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessMan/invalidPaperManagement"
                ),
              name: "作废纸张管理",
              meta: {
                title: "作废纸张管理",
                roles: ["zuofeizhizhangguanli"]
              },
              children: []
            },
            {
              path: "printerManagement",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/businessMan/printerManagement"
                ),
              name: "打印机盘点",
              meta: {
                title: "打印机盘点",
                roles: ["dayinjipandian"]
              },
              children: []
            },
            {
              path: "dailyCheck",
              component: () =>
                import("@/views/jyt/medicalRecord/businessMan/dailyCheck"),
              name: "日结盘点",
              meta: {
                title: "日结盘点",
                roles: ["rijiepandian"]
              },
              children: []
            },
            {
              path: "dailyDetail",
              component: () =>
                import("@/views/jyt/medicalRecord/businessMan/dailyDetail"),
              name: "日结明细",
              meta: {
                title: "日结明细",
                roles: ["rijiemingxi"]
              },
              children: []
            },
            {
              path: "dailySummary",
              component: () =>
                import("@/views/jyt/medicalRecord/businessMan/dailySummary"),
              name: "日结汇总",
              meta: {
                title: "日结汇总",
                roles: ["rijiehuizong"]
              },
              children: []
            },
            {
              path: "monthQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/businessMan/monthQuery"),
              name: "月结查询",
              meta: {
                title: "月结查询",
                roles: ["yuejiechaxun"]
              },
              children: []
            },
            {
              path: "EMSQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/businessMan/EMSQuery"),
              name: "EMS月结",
              meta: {
                title: "EMS月结",
                roles: ["EMSyuejie"]
              },
              children: []
            }
          ]
        },
        // {
        //   path: "mailHan",
        //   component: () => import("@/views/jyt/medicalRecord/mailHan/index"),
        //   meta: {
        //     title: "邮寄办理",
        //     roles: ["youjibanli"]
        //   },
        //   alwaysShow: true,
        //   children: [
        //     {
        //       path: "mailReceive",
        //       component: () =>
        //         import("@/views/jyt/medicalRecord/mailHan/mailReceive"),
        //       name: "邮寄接收",
        //       meta: {
        //         title: "邮寄接收",
        //         roles: ["youjijieshou"]
        //       },
        //       children: []
        //     },
        //     {
        //       path: "mailExport",
        //       component: () =>
        //         import("@/views/jyt/medicalRecord/mailHan/mailExport"),
        //       name: "邮寄导出",
        //       meta: {
        //         title: "邮寄导出",
        //         roles: ["youjidaochu"]
        //       },
        //       children: []
        //     },
        //     {
        //       path: "waitMailQuery",
        //       component: () =>
        //         import("@/views/jyt/medicalRecord/mailHan/waitMailQuery"),
        //       name: "待邮查询",
        //       meta: {
        //         title: "待邮查询",
        //         roles: ["daiyouchaxun"]
        //       },
        //       children: []
        //     },

        //     {
        //       path: "mailReceive2",
        //       component: () =>
        //         import("@/views/jyt/medicalRecord/mailHan/mailReceive2"),
        //       name: "邮寄接收-新",
        //       meta: {
        //         title: "邮寄接收-新",
        //         roles: ["youjijieshou"]
        //       },
        //       children: []
        //     }
        //   ]
        // },
        {
          path: "mailHanEMS",
          component: () => import("@/views/jyt/medicalRecord/mailHanEMS/index"),
          meta: {
            title: "邮寄办理(邮政EMS)",
            roles: ["youjibanli_ems"]
          },
          alwaysShow: true,
          children: [
            // {
            //   path: "mailReceive",
            //   component: () =>
            //     import("@/views/jyt/medicalRecord/mailHanEMS/mailReceive"),
            //   name: "邮寄接收-原",
            //   meta: {
            //     title: "邮寄接收",
            //     roles: ["youjijieshou"]
            //   },
            //   children: []
            // },
            {
              path: "mailReceive",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanEMS/mailReceive2"),
              name: "邮寄接收",
              meta: {
                title: "邮寄接收",
                roles: ["youjijieshou_ems"]
              },
              children: []
            },
            {
              path: "mailExport",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanEMS/mailExport"),
              name: "邮寄导出",
              meta: {
                title: "邮寄导出",
                roles: ["youjidaochu_ems"]
              },
              children: []
            },
            {
              path: "waitMailQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanEMS/waitMailQuery"),
              name: "待邮查询",
              meta: {
                title: "待邮查询",
                roles: ["daiyouchaxun_ems"]
              },
              children: []
            },

            
          ]
        },
        {
          path: "mailHanJD",
          component: () => import("@/views/jyt/medicalRecord/mailHanJD/index"),
          meta: {
            title: "邮寄办理(京东物流)",
            roles: ["youjibanli_jd"]
          },
          alwaysShow: true,
          children: [
            // {
            //   path: "mailReceive",
            //   component: () =>
            //     import("@/views/jyt/medicalRecord/mailHanJD/mailReceive"),
            //   name: "邮寄接收-原",
            //   meta: {
            //     title: "邮寄接收-原",
            //     roles: ["youjijieshou"]
            //   },
            //   children: []
            // },
            {
              path: "mailReceive",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanJD/mailReceive2"),
              name: "邮寄接收",
              meta: {
                title: "邮寄接收",
                roles: ["youjijieshou_jd"]
              },
              children: []
            },
            {
              path: "mailExport",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanJD/mailExport"),
              name: "邮寄导出",
              meta: {
                title: "邮寄导出",
                roles: ["youjidaochu_jd"]
              },
              children: []
            },
            {
              path: "waitMailQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanJD/waitMailQuery"),
              name: "待邮查询",
              meta: {
                title: "待邮查询",
                roles: ["daiyouchaxun_jd"]
              },
              children: []
            },
            
          ]
        },
        {
          path: "mailHanSF",
          component: () => import("@/views/jyt/medicalRecord/mailHanSF/index"),
          meta: {
            title: "邮寄办理(顺丰快递)",
            roles: ["youjibanli_sf"]
          },
          alwaysShow: true,
          children: [
            // {
            //   path: "mailReceive",
            //   component: () =>
            //     import("@/views/jyt/medicalRecord/mailHanSF/mailReceive"),
            //   name: "邮寄接收-原",
            //   meta: {
            //     title: "邮寄接收-原",
            //     roles: ["youjijieshou"]
            //   },
            //   children: []
            // },
            {
              path: "mailReceive",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanSF/mailReceive2"),
              name: "邮寄接收",
              meta: {
                title: "邮寄接收",
                roles: ["youjijieshou_sf"]
              },
              children: []
            },
            {
              path: "mailExport",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanSF/mailExport"),
              name: "邮寄导出",
              meta: {
                title: "邮寄导出",
                roles: ["youjidaochu_sf"]
              },
              children: []
            },
            {
              path: "waitMailQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/mailHanSF/waitMailQuery"),
              name: "待邮查询",
              meta: {
                title: "待邮查询",
                roles: ["daiyouchaxun_sf"]
              },
              children: []
            },

            
          ]
        },
        // 客服中心
        {
          path: "customerServiceCenter",
          component: () =>
            import("@/views/jyt/medicalRecord/customerServiceCenter/index"),
          meta: {
            title: "客服中心",
            roles: ["kefuzhongxin_bl"]
          },
          alwaysShow: true,
          children: [
            {
              path: "orderQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/orderQuery"
                ),
              name: "订单查询",
              meta: {
                title: "订单查询",
                roles: ["dingdanchaxun"]
              },
              children: []
            },
            {
              path: "mailInformationQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/mailInformationQuery"
                ),
              name: "邮寄信息",
              meta: {
                title: "邮寄信息",
                roles: ["youjixinxi"]
              },
              children: []
            },
            {
              path: "medicalRecordStateQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/medicalRecordStateQuery"
                ),
              name: "病案状态",
              meta: {
                title: "病案状态",
                roles: ["binganzhuangtai"]
              },
              children: []
            },
            {
              path: "settlementRefundQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/settlementRefundQuery"
                ),
              name: "结退查询",
              meta: {
                title: "结退查询",
                roles: ["jietuichaxun"]
              },
              children: []
            },
            {
              path: "exceptionHandling",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/exceptionHandling"
                ),
              name: "异常处理",
              meta: {
                title: "异常处理",
                roles: ["yichangchuli"]
              },
              children: []
            },
            {
              path: "businessAudit",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/businessAudit"
                ),
              name: "业务审核",
              meta: {
                title: "业务审核",
                roles: ["yewushenhe"]
              },
              children: []
            },
            {
              path: "settlementPayment",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/settlementPayment"
                ),
              name: "结算补缴",
              meta: {
                title: "结算补缴",
                roles: ["jiesuanbujiao"]
              },
              children: []
            },
            {
              path: "settlementRefund",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/customerServiceCenter/settlementRefund"
                ),
              name: "结算退款",
              meta: {
                title: "结算退款",
                roles: ["jiesuantuikuan"]
              },
              children: []
            }
          ]
        },
        {
          path: "financialMan",
          component: () =>
            import("@/views/jyt/medicalRecord/financialMan/index"),
          meta: {
            title: "财务管理",
            roles: ["caiwuguanli"]
          },
          alwaysShow: true,
          children: [
            {
              path: "EMSQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/financialMan/EMSQuery"),
              name: "快递统计",
              meta: {
                title: "快递统计",
                roles: ["EMSchaxun"]
              },
              children: []
            },
            {
              path: "dailySummary",
              component: () =>
                import("@/views/jyt/medicalRecord/financialMan/dailySummary"),
              name: "日结汇总",
              meta: {
                title: "日结汇总",
                roles: ["caiwurijiehuizong"]
              },
              children: []
            },
            {
              path: "dailyDetail",
              component: () =>
                import("@/views/jyt/medicalRecord/financialMan/dailyDetail"),
              name: "日结明细",
              meta: {
                title: "日结明细",
                roles: ["caiwurijiemingxi"]
              },
              children: []
            },
            {
              path: "refundQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/financialMan/refundQuery"),
              name: "已退查询",
              meta: {
                title: "已退查询",
                roles: ["yituichaxun"]
              },
              children: []
            },
            {
              path: "jhPaymentQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/financialMan/jhPaymentQuery"),
              name: "聚合支付查询",
              meta: {
                title: "聚合支付查询",
                roles: ["juhezhifuchaxun"]
              },
              children: []
            },
            {
              path: "jhReconciliationQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalRecord/financialMan/jhReconciliationQuery"
                ),
              name: "聚合对账查询",
              meta: {
                title: "聚合对账查询",
                roles: ["juheduizhangchaxun"]
              },
              children: []
            },
            {
              path: "wxPaymentQuery",
              component: () =>
                import("@/views/jyt/medicalRecord/financialMan/wxPaymentQuery"),
              name: "微信支付查询",
              meta: {
                title: "微信支付查询",
                roles: ["weixinzhifuchaxun"]
              },
              children: []
            },
            {
              path: "payRecorder",
              component: () =>
                import("@/views/jyt/medicalRecord/financialMan/payRecorder"),
              name: "对账查询",
              meta: {
                title: "对账查询",
                roles: ["duizhangchaxun"]
              },
              children: []
            }
          ]
        }
      ]
    },

    // 医废
    {
      path: "medicalWaste",
      component: () => import("@/views/jyt/medicalWaste/index"),
      meta: {
        title: "医废管理",
        roles: ["yifeiguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "wasteParamSetting",
          component: () => import("@/views/jyt/medicalWaste/wasteParamSetting"),
          name: "参数设置",
          meta: {
            title: "参数设置",
            roles: ["yifeicanshushezhi"]
          },
          children: []
        },
        {
          path: "deptTieIssue",
          component: () => import("@/views/jyt/medicalWaste/deptTieIssue"),
          name: "扎带管理",
          meta: {
            title: "扎带管理",
            roles: ["keshizadaifafang"]
          },
          children: []
        },
        {
          path: "businessMan",
          component: () => import("@/views/jyt/medicalWaste/businessMan/index"),
          name: "业务管理",
          meta: {
            title: "业务管理",
            roles: ["yfyewuguanli"]
          },
          alwaysShow: true,
          children: [
            {
              path: "comprehensiveDetailQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/comprehensiveDetailQuery"
                ),
              name: "综合明细查询",
              meta: {
                title: "综合明细查询",
                roles: ["yifeimingxizonghechaxun"]
              },
              children: []
            },
            // 综合明细查询(无签字)
            {
              path: "comprehensiveDetailQueryNoSign",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/comprehensiveDetailQueryNoSign"
                ),
              name: "医废明细查询",
              meta: {
                title: "医废明细查询",
                roles: ["yifeimingxizonghechaxunwuqianzi"]
              },
              children: []
            },
            {
              path: "medicalSummaryStatistical",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/medicalSummaryStatistical"
                ),
              name: "医废汇总统计",
              meta: {
                title: "医废汇总统计",
                roles: ["yifeihuizongtongji"]
              },
              children: []
            },
            {
              path: "handleOvertimeQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/handleOvertimeQuery"
                ),
              name: "处理超时查询",
              meta: {
                title: "处理超时查询",
                roles: ["yifeichulichaoshichaxun"]
              },
              children: []
            },
            {
              path: "deptSummaryQuery",
              component: () =>
                import("@/views/jyt/medicalWaste/businessMan/deptSummaryQuery"),
              name: "科室汇总查询",
              meta: {
                title: "科室汇总查询",
                roles: ["yifeikeshihuizongchaxun"]
              },
              children: []
            },
            {
              path: "collectionRecordQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/collectionRecordQuery"
                ),
              name: "收取记录",
              meta: {
                title: "收取记录",
                roles: ["yifeishouqujiluchaxun"]
              },
              children: []
            },
            {
              path: "outofRecordQuery",
              component: () =>
                import("@/views/jyt/medicalWaste/businessMan/outofRecordQuery"),
              name: "运出记录",
              meta: {
                title: "运出记录",
                roles: ["yifeiyunchujiluchaxun"]
              },
              children: []
            },
            {
              path: "handleWorkloadStatistical",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/handleWorkloadStatistical"
                ),
              name: "工作量统计",
              meta: {
                title: "工作量统计",
                roles: ["yifeichuligongzuoliangtongji"]
              },
              children: []
            },
            {
              path: "medicalWasteParameter",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/medicalWasteParameter"
                ),
              name: "医废转移联单",
              meta: {
                title: "医废转移联单",
                roles: ["yifeizhuanyiliandan_web"]
              },
              children: []
            },
            {
              path: "medicalWasteDisposalTable",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/medicalWasteDisposalTable"
                ),
              name: "医废产生处置表",
              meta: {
                title: "医废产生处置表",
                roles: ["yifeichanshengchuzhibiao_web"]
              },
              children: []
            },
            {
              path: "wasteDailyAccount",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/wasteDailyAccount"
                ),
              name: "医疗废弃物日账",
              meta: {
                title: "医疗废弃物日账",
                roles: ["yfrizhang"]
              },
              children: []
            },
            {
              path: "wasteMonthAccount",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/wasteMonthAccount"
                ),
              name: "医疗废弃物月账",
              meta: {
                title: "医疗废弃物月账",
                roles: ["yfyuezhang"]
              },
              children: []
            },
            {
              path: "wasteYearAccount",
              component: () =>
                import("@/views/jyt/medicalWaste/businessMan/wasteYearAccount"),
              name: "医疗废弃物年账",
              meta: {
                title: "医疗废弃物年账",
                roles: ["yfnianzhang"]
              },
              children: []
            },
            {
              path: "wasteStorageAccount",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/wasteStorageAccount"
                ),
              name: "危险废物入库台账",
              meta: {
                title: "危险废物入库台账",
                roles: ["weixianfeiwurukutaizhang"]
              },
              children: []
            },
            {
              path: "wasteDischargeAccount",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/wasteDischargeAccount"
                ),
              name: "危险废物出库台账",
              meta: {
                title: "危险废物出库台账",
                roles: ["weixianfeiwuchukutaizhang"]
              },
              children: []
            },
            {
              path: "unshippedQuery",
              component: () =>
                import("@/views/jyt/medicalWaste/businessMan/unshippedQuery"),
              name: "未运出查询",
              meta: {
                title: "未运出查询",
                roles: ["yfweiyunchuchaxun"]
              },
              children: []
            },
            {
              path: "updateQuery",
              component: () =>
                import("@/views/jyt/medicalWaste/businessMan/updateQuery"),
              name: "医废修改日志",
              meta: {
                title: "医废修改日志",
                roles: ["yfxiugairizhi"]
              },
              children: []
            },
            {
              path: "bluetoothScaleQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/bluetoothScaleQuery"
                ),
              name: "蓝牙设备查询",
              meta: {
                title: "蓝牙设备查询",
                roles: ["lanyachengchaxun"]
              },
              children: []
            },
            {
              path: "pdaQuery",
              component: () =>
                import("@/views/jyt/medicalWaste/businessMan/pdaQuery"),
              name: "PDA查询",
              meta: {
                title: "PDA查询",
                roles: ["pdachaxun"]
              },
              children: []
            },
            {
              path: "outputSummaryQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/outputSummaryQuery"
                ),
              hidden: true,
              name: "产出汇总查询",
              meta: {
                title: "产出汇总查询",
                roles: ["yifeichanchuhuizongchaxun"]
              },
              children: []
            },
            {
              path: "outofSummaryQuery",
              component: () =>
                import(
                  "@/views/jyt/medicalWaste/businessMan/outofSummaryQuery"
                ),
              hidden: true,
              name: "运出汇总查询",
              meta: {
                title: "运出汇总查询",
                roles: ["yifeiyunchuhuizongchaxun"]
              },
              children: []
            },
            {
              path: "outofDetailQuery",
              component: () =>
                import("@/views/jyt/medicalWaste/businessMan/outofDetailQuery"),
              hidden: true,
              name: "运出明细查询",
              meta: {
                title: "运出明细查询",
                roles: ["yifeiyunchumingxichaxun"]
              },
              children: []
            }
          ]
        }
      ]
    },

    // 被服
    {
      path: "clothingMan",
      component: () => import("@/views/jyt/clothingMan/index"),
      meta: {
        title: "被服管理",
        roles: ["beifuguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "setupMaintain",
          component: () =>
            import("@/views/jyt/clothingMan/setupMaintain/index"),
          meta: {
            title: "设置维护",
            roles: ["shezhiweihu_bf"]
          },
          alwaysShow: true,
          children: [
            {
              path: "clothingArchives",
              component: () =>
                import(
                  "@/views/jyt/clothingMan/setupMaintain/clothingArchives"
                ),
              name: "被服档案",
              meta: {
                title: "被服档案",
                roles: ["beifudangan"]
              },
              children: []
            },
            {
              path: "storageMan",
              component: () =>
                import("@/views/jyt/clothingMan/setupMaintain/storageMan"),
              name: "库房管理",
              meta: {
                title: "库房管理",
                roles: ["kufangguanli_bf"]
              },
              children: []
            },
            {
              path: "wardMan",
              component: () =>
                import("@/views/jyt/clothingMan/setupMaintain/wardMan"),
              name: "病房管理",
              meta: {
                title: "病房管理",
                roles: ["bingfangguanli"]
              },
              children: []
            },
            {
              path: "sickBedMan",
              component: () =>
                import("@/views/jyt/clothingMan/setupMaintain/sickBedMan"),
              name: "病床管理",
              meta: {
                title: "病床管理",
                roles: ["bingchuangguanli"]
              },
              children: []
            }
          ]
        },

        {
          path: "businessMan",
          component: () =>
            import("@/views/jyt/clothingMan/setupMaintain/index"),
          meta: {
            title: "业务管理",
            roles: ["yewuguanli_web"]
          },
          alwaysShow: true,
          children: [
            {
              path: "inventoryMan",
              component: () =>
                import("@/views/jyt/clothingMan/businessMan/inventoryMan"),
              name: "库存管理",
              meta: {
                title: "库存管理",
                roles: ["kucunguanli"]
              },
              children: []
            },
            {
              path: "purchasingList",
              component: () =>
                import("@/views/jyt/clothingMan/businessMan/purchasingList"),
              name: "采购汇总单",
              meta: {
                title: "采购汇总单",
                roles: ["caigouhuizongdan_web"]
              },
              children: []
            },
            {
              path: "officeNeedList",
              component: () =>
                import("@/views/jyt/clothingMan/businessMan/officeNeedList"),
              name: "科室需求单",
              meta: {
                title: "科室需求单",
                roles: ["keshixuqiudan_web"]
              },
              children: []
            },
            {
              path: "checkMan",
              component: () =>
                import("@/views/jyt/clothingMan/businessMan/checkMan"),
              name: "盘点管理",
              meta: {
                title: "盘点管理",
                roles: ["pandianguanli_bf"]
              },
              children: []
            },
            {
              path: "scrapMan",
              component: () =>
                import("@/views/jyt/clothingMan/businessMan/scrapMan"),
              name: "报废管理",
              meta: {
                title: "报废管理",
                roles: ["baofeiguanli"]
              },
              children: []
            },
            {
              path: "lossMan",
              component: () =>
                import("@/views/jyt/clothingMan/businessMan/lossMan"),
              name: "丢失管理",
              meta: {
                title: "丢失管理",
                roles: ["diushiguanli"]
              },
              children: []
            },
            {
              path: "processLossMan",
              component: () =>
                import(
                  "@/views/jyt/clothingMan/businessMan/processLossMan/index"
                ),
              name: "洗消丢失",
              meta: {
                title: "洗消丢失",
                roles: ["xixiaodiushi_web"]
              },
              children: []
            }
          ]
        },

        // 统计报表
        {
          path: "statisticalReports",
          component: () =>
            import("@/views/jyt/clothingMan/setupMaintain/index"),
          meta: {
            title: "统计报表",
            roles: ["tongjibaobiao_web"]
          },
          alwaysShow: true,
          children: [
            // 1 被服中心
            {
              path: "clothingCenter",
              meta: {
                title: "被服中心",
                roles: ["beifuzhongxinbaobiao_web"]
              },
              component: () =>
                import("@/views/adminMan/vehicleMan/vehicleMan/index"),
              children: [
                {
                  path: "tagInStoreHistoryQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/tagInStoreHistoryQuery/index"
                    ),
                  name: "rfid标签入库查询",
                  meta: {
                    title: "rfid标签入库查询",
                    roles: ["rfidbiaoqianrukuchaxun_web"]
                  }
                },

                // rfid标签查询
                {
                  path: "tagQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/tagQuery/index"
                    ),
                  name: "rfid标签查询",
                  meta: {
                    title: "rfid标签查询",
                    roles: ["rfidbiaoqianchaxun_web"]
                  }
                },

                {
                  path: "purchaseInboundOrderQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/purchaseInboundOrderQuery/index"
                    ),
                  name: "采购入库单查询",
                  meta: {
                    title: "采购入库单查询",
                    roles: ["caigourukudan_web"]
                  }
                },
                // 中心发放单查询
                {
                  path: "centreIssuesOrderQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/centreIssuesOrderQuery/index"
                    ),
                  name: "中心发放单查询",
                  meta: {
                    title: "中心发放单查询",
                    roles: ["zhongxinfafangdanchaxun_web"]
                  }
                },
                // 洗消收取单查询
                {
                  path: "washAwayChargeOrderQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/washAwayChargeOrderQuery/index"
                    ),
                  name: "洗消收取单查询",
                  meta: {
                    title: "洗消收取单查询",
                    roles: ["xixiaoshouqudanchaxun_web"]
                  }
                },
                // 中心送洗单查询
                {
                  path: "centreWashedOrderQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/centreWashedOrderQuery/index"
                    ),
                  name: "中心送洗单查询",
                  meta: {
                    title: "中心送洗单查询",
                    roles: ["zhongxinsongxidanchaxun_web"]
                  }
                },
                // 中心取回单查询
                {
                  path: "centreBackOrderQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/centreBackOrderQuery/index"
                    ),
                  name: "中心取回单查询",
                  meta: {
                    title: "中心取回单查询",
                    roles: ["zhongxinquhuidanchaxun_web"]
                  }
                },

                // 洗消发放单查询
                {
                  path: "washIssuesOrderQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/washIssuesOrderQuery/index"
                    ),
                  name: "洗消发放单查询",
                  meta: {
                    title: "洗消发放单查询",
                    roles: ["xixiaofafangdanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "washAndSortOrderQuery",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/clothingCenter/washAndSortOrderQuery/index"
                    ),
                  name: "洗消分拣单查询",
                  meta: {
                    title: "洗消分拣单查询",
                    roles: ["xixiaofenjiandanchaxun_web"]
                  }
                }
                // ///////////////
              ]
            },

            {
              path: "decontaminationCenter",
              component: () =>
                // import("@/views/jyt/clothingMan/statisticalReports/decontaminationCenter/index"),

                import("@/views/adminMan/vehicleMan/vehicleMan/index"),
              meta: {
                title: "洗消中心报表",
                roles: ["xixiaozhongxinbaobiao_web"]
              },
              alwaysShow: true,
              children: [
                {
                  path: "decontaminationReceptionInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/decontaminationCenter/decontaminationReceptionInquire/index"
                    ),
                  name: "洗消接收单查询",
                  meta: {
                    title: "洗消接收单查询",
                    roles: ["xixiaojieshoudanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "decontaminationHandoverInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/decontaminationCenter/decontaminationHandoverInquire/index"
                    ),
                  name: "洗消交接单查询",
                  meta: {
                    title: "洗消交接单查询",
                    roles: ["xixiaojiaojiedanchaxun_web"]
                  },
                  children: []
                }
              ]
            },
            {
              path: "officeClothingStatement",
              component: () =>
                // import("@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/index"),
                import("@/views/adminMan/vehicleMan/vehicleMan/index"),

              meta: {
                title: "科室业务报表",
                roles: ["keshiyewubaobiao_web"]
              },
              alwaysShow: true,
              children: [
                {
                  path: "officeLaundryInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/officeLaundryInquire/index"
                    ),
                  name: "科室送洗单查询",
                  meta: {
                    title: "科室送洗单查询",
                    roles: ["keshisongxidanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "officeRecycleInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/officeRecycleInquire/index"
                    ),
                  name: "科室回收单查询",
                  meta: {
                    title: "科室回收单查询",
                    roles: ["keshihuishoudanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "officeGrantInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/officeGrantInquire/index"
                    ),
                  name: "科室发放单查询",
                  meta: {
                    title: "科室发放单查询",
                    roles: ["keshifafangdanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "lostOutInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/lostOutInquire/index"
                    ),
                  name: "丢失发放单查询",
                  meta: {
                    title: "丢失发放单查询",
                    roles: ["diushifafangdanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "lostPutStorageInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/lostPutStorageInquire/index"
                    ),
                  name: "丢失入库单查询",
                  meta: {
                    title: "丢失入库单查询",
                    roles: ["diushirukudanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "officeWarehouseWarrantInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/officeWarehouseWarrantInquire/index"
                    ),
                  name: "按需入库单查询",
                  meta: {
                    title: "按需入库单查询",
                    roles: ["keshianxurukudanchaxun_web"]
                  },
                  children: []
                },
                {
                  path: "officeDecontaminationInquire",
                  component: () =>
                    import(
                      "@/views/jyt/clothingMan/statisticalReports/officeClothingStatement/officeDecontaminationInquire/index"
                    ),
                  name: "洗消入库单查询",
                  meta: {
                    title: "洗消入库单查询",
                    roles: ["keshixixiaorukudanchaxun_web"]
                  },
                  children: []
                }
              ]
            }
          ]
        }

        // {
        //   path: "clothingClean",
        //   component: () => import("@/views/jyt/clothingMan/clothingClean"),
        //   name: "被服洗消",
        //   meta: {
        //     title: "被服洗消",
        //     roles: ["beifuxixiao"]
        //   },
        //   children: []
        // }
      ]
    },

    // 运送
    {
      path: "transportMan",
      component: () => import("@/views/jyt/transportMan/index"),
      meta: {
        title: "运送管理",
        roles: ["yunsongguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "serviceMan",
          name: "调度中心",
          component: () => import("@/views/jyt/transportMan/serviceMan"),
          meta: {
            title: "调度中心",
            roles: ["diaoduzhongxin"]
          }
        },
        {
          path: "tranConfig",
          component: () => import("@/views/jyt/transportMan/tranConfig/index"),
          name: "运送配置",
          meta: {
            title: "运送配置",
            roles: ["yunsongpeizhi"]
          },
          children: []
        },
        {
          path: "tranLoop",
          component: () => import("@/views/jyt/transportMan/tranLoop/index"),
          name: "循环运送",
          meta: {
            title: "循环运送",
            roles: ["xunhuanyunsong"]
          },
          children: []
        },
        {
          path: "statisticalStatement",
          component: () =>
            import("@/views/jyt/transportMan/statisticalStatement/index"),
          name: "统计报表",
          meta: {
            title: "统计报表"
            // roles: ["xunhuanyunsong"]
          },
          children: [
            {
              path: "workloadStatistics",
              component: () =>
                import(
                  "@/views/jyt/transportMan/statisticalStatement/workloadStatistics"
                ),
              name: "运送员工作量统计",
              meta: {
                title: "运送员工作量统计"
                // roles: ["xunhuanyunsong"]
              },
              children: []
            },
            {
              path: "shipClassification",
              component: () =>
                import(
                  "@/views/jyt/transportMan/statisticalStatement/shipClassification"
                ),
              name: "运送分类统计表",
              meta: {
                title: "运送分类统计表"
                // roles: ["xunhuanyunsong"]
              },
              children: []
            },
            {
              path: "shipCollect",
              component: () =>
                import(
                  "@/views/jyt/transportMan/statisticalStatement/shipCollect"
                ),
              name: "运送科室汇总统计",
              meta: {
                title: "运送科室汇总统计"
                // roles: ["xunhuanyunsong"]
              },
              children: []
            }
          ]
        }
      ]
    },

    // 陪护
    {
      path: "escortMan",
      component: () => import("@/views/jyt/escortMan/index"),
      meta: {
        title: "陪护服务",
        roles: ["peihufuwu"]
      },
      alwaysShow: true,
      children: [
        {
          path: "escortSetting",
          component: () => import("@/views/jyt/escortMan/escortSetting"),
          name: "陪护设置",
          meta: {
            title: "陪护设置",
            roles: ["peihushezhi"]
          },
          children: []
        },
        {
          path: "careAudit",
          component: () => import("@/views/jyt/escortMan/careAudit"),
          name: "护工审核",
          meta: {
            title: "护工审核",
            roles: ["hugongshenhe"]
          },
          children: []
        },
        {
          path: "careMan",
          component: () => import("@/views/jyt/escortMan/careMan"),
          name: "护工管理",
          meta: {
            title: "护工管理",
            roles: ["hugongguanli"]
          },
          children: []
        },
        {
          path: "evaluationMan",
          component: () => import("@/views/jyt/escortMan/evaluationMan"),
          name: "评价管理",
          meta: {
            title: "评价管理",
            roles: ["hgpingjiaguanli"]
          },
          children: []
        },
        {
          path: "orderMan",
          component: () => import("@/views/jyt/escortMan/orderMan"),
          name: "订单管理",
          meta: {
            title: "订单管理",
            roles: ["hgdingdanguanli"]
          },
          children: []
        }
      ]
    },

    // 陪诊陪检
    {
      path: "accompany",
      component: () => import("@/views/jyt/accompany/index"),
      meta: {
        title: "陪诊陪检",
        roles: ["peizhenpeijian"]
      },
      alwaysShow: true,
      children: [
        {
          path: "accompanySetup",
          component: () => import("@/views/jyt/accompany/accompanySetup"),
          name: "陪诊陪检设置",
          meta: {
            title: "陪诊陪检设置",
            roles: ["peizhenpeijianshezhi"]
          }
        },
        {
          path: "orderMan",
          component: () => import("@/views/jyt/accompany/orderMan"),
          name: "订单管理",
          meta: {
            title: "订单管理",
            roles: ["dingdanguanli"]
          }
        },
        {
          path: "orderAssign",
          component: () => import("@/views/jyt/accompany/orderAssign"),
          name: "订单指派",
          meta: {
            title: "订单指派",
            roles: ["dingdanzhipai"]
          }
        }
      ]
    },

    // 随访管理
    {
      path: "followupMan",
      component: () => import("@/views/jyt/followupMan/index"),
      meta: {
        title: "随访管理",
        roles: ["suifangguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "basicInformation",
          component: () =>
            import("@/views/jyt/followupMan/basicInformation/index"),
          meta: {
            title: "基础信息维护",
            roles: ["jichuxinxiweihu"]
          },
          alwaysShow: true,
          children: [
            {
              path: "patientInformation",
              component: () =>
                import(
                  "@/views/jyt/followupMan/basicInformation/patientInformation"
                ),
              name: "就诊信息",
              meta: {
                title: "就诊信息",
                roles: ["huanzhexinxi"]
              }
            },
            {
              path: "diseaseInformation",
              component: () =>
                import(
                  "@/views/jyt/followupMan/basicInformation/diseaseInformation"
                ),
              name: "病种信息",
              meta: {
                title: "病种信息",
                roles: ["bingzhongxinxi"]
              }
            },
            {
              path: "illnessInformation",
              component: () =>
                import(
                  "@/views/jyt/followupMan/basicInformation/illnessInformation"
                ),
              name: "疾病信息",
              meta: {
                title: "疾病信息",
                roles: ["jibingxinxi"]
              }
            },
            {
              path: "drugInformation",
              component: () =>
                import(
                  "@/views/jyt/followupMan/basicInformation/drugInformation"
                ),
              name: "药品信息",
              meta: {
                title: "药品信息",
                roles: ["yaopinxinxi"]
              }
            }
          ]
        },
        {
          path: "healthPromotion",
          component: () =>
            import("@/views/jyt/followupMan/healthPromotion/index"),
          meta: {
            title: "健康宣传维护",
            roles: ["jiankangxuanjiaoweihu"]
          },
          alwaysShow: true,
          children: [
            {
              path: "healthPromotion",
              component: () =>
                import(
                  "@/views/jyt/followupMan/healthPromotion/healthPromotion"
                ),
              name: "健康宣传维护",
              meta: {
                title: "健康宣传维护",
                roles: ["jkjiankangxuanjiaoweihu"]
              },
              children: []
            }
          ]
        },
        {
          path: "statistical",
          component: () => import("@/views/jyt/followupMan/statistical/index"),
          meta: {
            title: "统计查询",
            roles: ["tongjichaxun"]
          },
          alwaysShow: true,
          children: [
            {
              path: "satisfactionQuery",
              component: () =>
                import("@/views/jyt/followupMan/statistical/satisfactionQuery"),
              name: "满意度调查统计",
              meta: {
                title: "满意度调查统计",
                roles: ["manyidudiaochatongji"]
              },
              children: []
            },
            {
              path: "followupWork",
              component: () =>
                import("@/views/jyt/followupMan/statistical/followupWork"),
              name: "随访工作统计",
              meta: {
                title: "随访工作统计",
                roles: ["suifanggongzuotongji"]
              },
              children: []
            },
            {
              path: "followupRecord",
              component: () =>
                import("@/views/jyt/followupMan/statistical/followupRecord"),
              name: "随访记录统计",
              meta: {
                title: "随访记录统计",
                roles: ["suifangjilutongji"]
              },
              children: []
            }
          ]
        },
        {
          path: "followupCenter",
          component: () =>
            import("@/views/jyt/followupMan/followupCenter/index"),
          meta: {
            title: "中心随访",
            roles: ["zhongxinsuifang"]
          },
          alwaysShow: true,
          children: [
            {
              path: "surveyFileSetting",
              component: () =>
                import(
                  "@/views/jyt/followupMan/followupCenter/surveyFileSetting"
                ),
              name: "调查问卷设置",
              meta: {
                title: "调查问卷设置",
                roles: ["diaochawenjuanshezhi"]
              },
              children: []
            },
            {
              path: "satisfactionSurvey",
              component: () =>
                import(
                  "@/views/jyt/followupMan/followupCenter/satisfactionSurvey"
                ),
              name: "满意度调查",
              meta: {
                title: "满意度调查",
                roles: ["manyidudiaocha"]
              },
              children: []
            },
            {
              path: "followupMan",
              component: () =>
                import(
                  "@/views/jyt/followupMan/followupCenter/followupManagement"
                ),
              name: "中心随访",
              meta: {
                title: "中心随访",
                roles: ["zxzhongxinsuifang"]
              },
              children: []
            },
            {
              path: "appointReminder",
              component: () =>
                import(
                  "@/views/jyt/followupMan/followupCenter/appointReminder"
                ),
              name: "复诊提醒",
              meta: {
                title: "复诊提醒",
                roles: ["fuzhentixing"]
              },
              children: []
            }
          ]
        },
        {
          path: "dynamicForm",
          component: () => import("@/views/jyt/followupMan/dynamicForm/index"),
          meta: {
            title: "动态表单维护",
            roles: ["dongtaibiaodanweihu"]
          },
          alwaysShow: true,
          children: [
            {
              path: "dynamicForm",
              component: () =>
                import("@/views/jyt/followupMan/dynamicForm/dynamicForm"),
              name: "动态表单维护",
              meta: {
                title: "动态表单维护",
                roles: ["dongtaibiaodanweihu"]
              },
              children: []
            }
          ]
        },
        {
          path: "tagMaintain",
          component: () => import("@/views/jyt/followupMan/tagMaintain/index"),
          meta: {
            title: "标签维护",
            roles: ["biaoqianweihu"]
          },
          alwaysShow: true,
          children: [
            {
              path: "tagMaintain",
              component: () =>
                import("@/views/jyt/followupMan/tagMaintain/tagMaintain"),
              name: "标签维护",
              meta: {
                title: "标签维护",
                roles: ["biaoqianweihu"]
              },
              children: []
            },
            {
              path: "tagTypeMaintain",
              component: () =>
                import("@/views/jyt/followupMan/tagMaintain/tagTypeMaintain"),
              name: "标签类别维护",
              meta: {
                title: "标签类别维护",
                roles: ["biaoqianweihu"]
              },
              children: []
            }
          ]
        }
      ]
    },

    {
      path: "drugMail",
      component: () => import("@/views/jyt/drugMail/index"),
      meta: {
        title: "药品邮寄",
        roles: ["yaopinyouji"]
      },
      alwaysShow: true,
      children: [
        {
          path: "drugMailMan",
          component: () => import("@/views/jyt/drugMail/drugMailMan"),
          name: "药品待邮管理",
          meta: {
            title: "药品待邮管理",
            roles: ["yaopindaiyouguanli"]
          },
          children: []
        },
        {
          path: "drugMailConfirm",
          component: () => import("@/views/jyt/drugMail/drugMailConfirm"),
          name: "药品邮寄确认",
          meta: {
            title: "药品邮寄确认",
            roles: ["yaopinyoujiqueren"]
          },
          children: []
        },
        {
          path: "drugTranQuery",
          component: () => import("@/views/jyt/drugMail/drugTranQuery"),
          name: "药品运送查询",
          meta: {
            title: "药品运送查询",
            roles: ["yaopinyunsongqueren"]
          },
          children: []
        },
        {
          path: "drugMailQuery",
          component: () => import("@/views/jyt/drugMail/drugMailQuery"),
          name: "药品邮寄查询",
          meta: {
            title: "药品邮寄查询",
            roles: ["yaopinyoujichaxun"]
          },
          children: []
        },
        {
          path: "drugMailSettlement",
          component: () => import("@/views/jyt/drugMail/drugMailSettlement"),
          name: "药品邮寄结算",
          meta: {
            title: "药品邮寄结算",
            roles: ["yaopinyoujijiesuan"]
          },
          children: []
        },
        {
          path: "drugMailStatistics",
          component: () => import("@/views/jyt/drugMail/drugMailStatistics"),
          name: "药品邮寄统计",
          meta: {
            title: "药品邮寄统计",
            roles: ["yaopinyoujitongji"]
          },
          children: []
        }
      ]
    },
    // 陪护床报表
    {
      path: "rentalServices",
      component: () => import("@/views/jyt/drugMail/index"),
      meta: {
        title: "租用服务",
        roles: ["zuyongfuwu"]
      },
      alwaysShow: true,
      children: [
        {
          path: "escortLockMan",
          component: () => import("@/views/jyt/escortBedRent/escortLockMan"),
          name: "蓝牙锁电量查询",
          meta: {
            title: "蓝牙锁电量查询",
            roles: ["lanyasuodianliangchaxun"]
          },
          children: []
        },
        {
          path: "nursingBedReportForm",
          component: () => import("@/views/jyt/nursingBedReportForm/index"),
          name: "租用查询",
          meta: {
            title: "租用查询",
            roles: ["zuyongchaxun"]
          },
          children: []
        },
        {
          path: "businessAnalysisForm",
          component: () => import("@/views/jyt/businessAnalysisForm"),
          name: "经营分析表",
          meta: {
            title: "经营分析表",
            roles: ["jingyingfenxibiao"]
          },
          children: []
        },

        {
          path: "escortBedOrder",
          component: () => import("@/views/jyt/escortBedOrder/index"),
          name: "陪护床订单管理",
          meta: {
            title: "陪护床订单管理",
            roles: ["peihuchuangdingdanguanli"]
          },
          children: []
        },
        {
          path: "wheelchairOrder",
          component: () => import("@/views/jyt/wheelchairOrder/index"),
          name: "轮椅订单管理",
          meta: {
            title: "轮椅订单管理",
            roles: ["peihuchuangdingdanguanli"]
          },
          children: []
        },
        {
          path: "productOrderQuery",
          component: () =>
            import("@/views/jyt/escortBedOrder/productOrderQuery"),
          name: "商品订单查询",
          meta: {
            title: "商品订单查询",
            roles: ["shangpindingdanchaxun"]
          },
          children: []
        },

        {
          path: "disinfectHistory",
          component: () =>
            import("@/views/jyt/rentalServices/disinfectHistory"),
          name: "消杀记录",
          meta: {
            title: "消杀记录",
            roles: ["xiaoshajilu"]
          },
          children: []
        }
      ]
    }

    // {
    //   path: "nursingBedReportForm",
    //   component: () => import("@/views/jyt/nursingBedReportForm"),
    //   name: "陪护床租用查询",
    //   meta: {
    //     title: "陪护床租用查询",
    //     roles: ["peihuchuangzuyongchaxun"]
    //   },
    //   children: []
    // },
    // // 经营分析表  businessAnalysis
    // {
    //   path: "businessAnalysisForm",
    //   component: () => import("@/views/jyt/businessAnalysisForm"),
    //   name: "经营分析表",
    //   meta: {
    //     title: "经营分析表",
    //     roles: ["peihuchuangzuyongchaxun"]
    //   },
    //   children: []
    // },

    // 客服中心
    // {
    //   path: "customerMan",
    //   component: () => import("@/views/jyt/customerMan/index"),
    //   meta: {
    //     title: "客服中心",
    //     roles: ["kefuzhongxin"]
    //   },
    //   children: [
    //     {
    //       path: "complaintSuggestion",
    //       component: () =>
    //         import("@/views/jyt/customerMan/complaintSuggestion/index"),
    //       meta: {
    //         title: "投诉建议",
    //         roles: ["tousujianyi"]
    //       },
    //       children: [
    //         {
    //           path: "feedbackMan",
    //           component: () =>
    //             import(
    //               "@/views/jyt/customerMan/complaintSuggestion/feedbackMan"
    //             ),
    //           name: "反馈查询",
    //           meta: {
    //             title: "反馈查询",
    //             roles: ["fankuichaxun"]
    //           }
    //         },
    //         {
    //           path: "complaintHandle",
    //           component: () =>
    //             import(
    //               "@/views/jyt/customerMan/complaintSuggestion/complaintHandle"
    //             ),
    //           name: "投诉处理",
    //           meta: {
    //             title: "投诉处理",
    //             roles: ["tousuchuli"]
    //           }
    //         }
    //       ]
    //     },
    //     {
    //       path: "accompany",
    //       component: () => import("@/views/jyt/customerMan/accompany/index"),
    //       meta: {
    //         title: "陪诊陪检",
    //         roles: ["kfpeizhenpeijian"]
    //       },
    //       children: [
    //         {
    //           path: "accompanyTrace",
    //           component: () =>
    //             import("@/views/jyt/customerMan/accompany/accompanyTrace"),
    //           name: "陪诊陪检跟踪",
    //           meta: {
    //             title: "陪诊陪检跟踪",
    //             roles: ["kfpeizhenpeijiangenzong"]
    //           }
    //         },
    //         {
    //           path: "traceRecord",
    //           component: () =>
    //             import("@/views/jyt/customerMan/accompany/traceRecord"),
    //           name: "跟踪记录查询",
    //           meta: {
    //             title: "跟踪记录查询",
    //             roles: ["kfgenzongjiluchaxun"]
    //           }
    //         }
    //       ]
    //     }
    //   ]
    // }
  ]
};

export default jtyRouter;
